import { render, staticRenderFns } from "./bvideoflow.vue?vue&type=template&id=0c03f2fe&lang=pug&"
import script from "./bvideoflow.vue?vue&type=script&lang=js&"
export * from "./bvideoflow.vue?vue&type=script&lang=js&"
import style0 from "./bvideoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports